import { ListingAttributes } from '@/components/listing/listing/Listing.interfaces';
import { ListingStatus } from '@proprioo/hokkaido';

export const filterLostListings = (
  listings: ListingAttributes[]
): ListingAttributes[] =>
  listings.filter(
    ({ status }: ListingAttributes) => status !== ListingStatus.LOST
  );
